import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import ClickOutside from 'vue-click-outside';
import { scrollTo } from '../../../_scripts/helpers';

export default {
	template: "#checkout-customer",
	props: {
		step: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			profileId: null,
			addingNewProfile: false,
			editingUserProfile: false,
			showNewConsigneeForm: false,
			sellerCodeFieldIsVisible: false,
			formValidator: null,
			propsData: {}
		}
	},
	components: {
	},
	computed: {
        ...mapGetters({
			personTypes: "customer/personTypes",
			userProfiles: "customer/userProfiles",
			activePersonType: "customer/activePersonType",
			activeUserProfile: "customer/activeUserProfile",
			activeStep: "checkout/activeStep",
		}),
		...mapState({
			props: state => state.customer.props,
			errorMessages: state => state.checkout.errorMessages,
			dadataToken: state => state.checkout.dadataToken,
			extra: state => state.checkout.extra
		}),
		showNewProfileForm() {
			return (!this.userProfiles.length || this.addingNewProfile) ? true : false;
		},
		formProps() {
			return this.props.filter(prop => {
				if (prop.code === 'SECOND_NAME' ||
					prop.code === 'NAME' ||
					prop.code === 'OTCHESTVO' ||
					prop.code === 'EMAIL' ||
					prop.code === 'PHONE') {
					let value = decodeURIComponent(this.getCookie(prop.code));
					if (prop.value === '') {
						let value = decodeURIComponent(this.getCookie(prop.code));
						prop.value = value;
					} else {
						document.cookie = prop.code + `=;expires=${new Date(0)}`;
					}
				}
				return prop.code !== "PROFILE_ID" &&
					prop.code !== "SELLER_ID" &&
					prop.code !== "CONSIGNEE_FIO" &&
					prop.code !== "CONSIGNEE_PHONE";
			});
		},
		consigneeFormProps() {
			return this.props.filter(prop => (((prop.code === "CONSIGNEE_FIO") || (prop.code === "CONSIGNEE_PHONE"))));
		},
		sellerCodeFormField() {
			return this.props.find(prop => prop.code === "SELLER_ID");
		},

		stepDisabled() {
			return this.step.disabled;
		},
		isActive() {
			return this.step.id === this.activeStep.id;
		},
		showPropsInfo() {
			return Object.values(this.propsData).some(data => data.info);
		},
		userProfilesNoDisabled() {
			return this.userProfiles.filter(profile => !profile.disabled)
		},
		isUserProfilesDisabled() {
			return this.userProfiles.filter(profile => profile.disabled).length == this.userProfiles.length ? true : false
		},
		isAddNewProfileButtonVisible() {
			if (typeof this.extra.showAddNewProfileButton !== "undefined") {
				return this.extra.showAddNewProfileButton;
			} else {
				return !this.addingNewProfile && !this.isUserProfilesDisabled;
			}
		}
	},
	methods: {
		...mapMutations({
			setPropValueMutation: "customer/setPropValue",
			setActivePersonType: "customer/setActivePersonType",
			setActiveUserProfileMutation: "customer/setActiveUserProfile",
			unselectUserProfiles: "customer/unselectUserProfiles",
			setStepValidState: "checkout/setStepValidState"
		}),
		...mapActions({
			refreshOrder: "checkout/refreshOrder",
			nextStep: "checkout/nextStep",
			blockSteps: "checkout/blockSteps"
		}),
		clickOutside(e) {
			if (this.isActive && this.activePersonType) {
				this.touchForm();
			}
		},
		addNewProfile() {
			this.addingNewProfile = true;
			this.editingUserProfile = false;
			this.clearFormProps();
			this.unselectUserProfiles();
			this.initForm();
			this.$nextTick(() => {
				scrollTo(this.$refs.formTitle);
			});
		},
		showSellerCodeField() {
			this.sellerCodeFieldIsVisible = true;
			this.reinitInputs();
		},
		reinitInputs() {
			this.$nextTick(() => {
				if (window.initInputModern) window.initInputModern();
			});
		},
		handleFormInput(e, code) {
			let value = e.target.value;
			this.setPropValueMutation({value, code});
			let prop = this.formProps.find(prop => prop.code === code);
			if (prop.handler) {
				if (!this.propsData[prop.id]) {
					this.$set(this.propsData, [prop.id], {
						info: false,
						message: ""
					});
				}
				$.ajax({
					url: prop.handler,
					type: "GET",
					dataType: "json",
					data: {
						"EMAIL": value
					},
					success: (res) => {
						let info = (res.success) ? true : false;
						let message = (res.success) ? prop.handlerMessage : "";

						this.propsData[prop.id].info = info;
						this.propsData[prop.id].message = message;
					}
				});
			}
			this.checkComponentValidity();
		},
		handleFormBlur(e) {
			e.target.dispatchEvent(new Event("input"));
		},
		clearFormProps() {
			this.formProps.forEach(prop => this.setPropValueMutation({value: "", code: prop.code}))
		},
		changeType(id) {
			this.addingNewProfile = false;
			this.editingUserProfile = false;
			this.unselectUserProfiles();
			this.setActivePersonType(id);
			this.refreshOrder().then(() => {
				this.initForm();
				this.checkComponentValidity();
			});
		},
		setActiveUserProfile(id) {
			this.profileId = id;
			this.setActiveUserProfileMutation(id);
			this.addingNewProfile = false;
			this.editingUserProfile = false;
			this.refreshOrder().then(() => {
				this.checkComponentValidity();
			});
		},
		editUserProfile(id) {
			this.addingNewProfile = false;
			this.editingUserProfile = true;
			this.setActiveUserProfileMutation(id);
			this.refreshOrder().then(() => {
				this.initForm();
				this.checkComponentValidity();
				scrollTo(this.$refs.formTitle);
			});
		},
		initForm() {
			this.reinitInputs();
			this.formValidator = $(this.$refs.form).validate();
			this.initDadata();
		},
		initDadata() {
			this.$nextTick(() => {
				let fields = [
					$("[data-checkout-input-code='INN']").find("input"),
					$("[data-checkout-input-code='KPP']").find("input"),
					$("[data-checkout-input-code='COMPANY']").find("input")
				];

				fields.forEach($field => {
					$field.suggestions({
						token: this.dadataToken,
						type: "PARTY",
						hint: false,
						onSelect: (suggestion) => {
							this.setPropValueMutation({value: suggestion.data.inn, code: "INN"});
							this.setPropValueMutation({value: suggestion.data.kpp, code: "KPP"});
							this.setPropValueMutation({value: suggestion.data.name.full_with_opf, code: "COMPANY"});
							this.$nextTick(() => {
								fields.forEach(field => {
									(field.val()) ? field.parent().addClass("is-changed") : field.parent().removeClass("is-changed");
								});
								this.checkComponentValidity();
							});
						}
					});
				});
			})
		},
		touchForm() {
			$(this.$refs.form).valid();
		},
		resetForm() {
			this.formValidator.resetForm();
		},
		getUserProfileProperties() {
			if (this.activePersonType) {
				if (this.activePersonType.ID === "1") {
					return [
						{
							property: "phone"
						},
						{
							property: "email"
						}
					]
				} else if (this.activePersonType.ID === "2") {
					return [
						{
							text: "ИНН",
							property: "inn"
						},
						{
							property: "second"
						},
						{
							property: "email"
						},
						{
							property: "phone"
						}
					]
				}
			}
		},
		isFormValid() {
			const result = this.formValidator.checkForm();
			this.formValidator.submitted = {};
			return result;
		},
		checkComponentValidity(reset = false) {
			this.$nextTick(() => {
				if (!this.activePersonType) return;
				let valid = false;

				if (this.showNewProfileForm || this.editingUserProfile) {
					valid = this.isFormValid() ? true : false;
					if (valid) {
						var pattern =  new RegExp("^"+'\\+\\d \\d{3} \\d{3}-\\d{2}-\\d{2}'+"","i");
						valid = (pattern.test($('input[name="ORDER_PROP_3"]').val()) || pattern.test($('input[name="ORDER_PROP_13"]').val())) ? true : false;
					}
				} else {
					valid = this.activeUserProfile ? true : false;
				}

				if (!valid) {
					$('.errorValid').css('display', 'block');
				} else {
					$('.errorValid').css('display', 'none');
				}
				let validConsignee = true;
				if (this.showNewConsigneeForm) {
					var pattern =  new RegExp("^"+'\\+\\d \\d{3} \\d{3}-\\d{2}-\\d{2}'+"","i");
					validConsignee = pattern.test($('input[name="CONSIGNEE_PHONE"]').val()) ? true : false;
				}

				if (valid && validConsignee) {
					this.setStepValidState({stepId: this.step.id, value: true});
					this.nextStep(this.step);
				} else {
					this.setStepValidState({stepId: this.step.id, value: false});
					this.blockSteps();
				}

				if (reset) setTimeout(() => this.resetForm(), 0);
			})
		},
		getCookie(n)
		{
			var r = new RegExp("(.*?"+n+"=)(.*?)((;.*)|$)");
			var c = document.cookie;
			if (c.match( r ))
			{
				return c.replace(r, "$2");
			} else {
				return "";
			}
		}
	},
	watch: {
		addingNewProfile() {
			this.$nextTick(() => this.checkComponentValidity());
		},
		showNewConsigneeForm() {
			this.$nextTick(() => {
				this.initForm();
				this.checkComponentValidity();
			});
		},
		stepDisabled(val) {
			if (!val) {
				this.$nextTick(() => {
					this.checkComponentValidity(true);
				});
			}
		},
		formProps() {
			this.$nextTick(() => {
				this.$el.querySelectorAll("[data-input]").forEach(input => {
					if (input.inputModule) input.inputModule._checkChange();
				});
			});
		}
	},
	directives: {
		ClickOutside
	},
	mounted() {
		this.initForm();
	},
	created() {
		if ("addingNewProfile" in this.extra) this.addingNewProfile = this.extra.addingNewProfile;

	}
}
